export default "__VITE_ASSET__CIInxhCk__"